export default __webpack_public_path__ + "48de30295c71e85a21d6cf17771307f5.png";